import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import { useLocation, useNavigate } from "react-router";

import { routes } from "../config";

export const NavigationMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const currentRoute = routes.find(({ routeRegex, path }) =>
    routeRegex ? routeRegex.test(pathname) : path === pathname,
  );
  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (navigateTo: string) => {
    setAnchorEl(null);
    navigate(navigateTo);
  };

  if (!currentRoute) return null;

  return (
    <Box sx={{ alignSelf: "flex-end" }}>
      <Button
        id="basic-button"
        aria-controls={isOpen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
        onClick={handleClick}
      >
        {currentRoute.name}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={isOpen}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {routes
          .filter(
            ({ hideFromNavigation, path }) =>
              !hideFromNavigation &&
              path !== "/login" &&
              path !== currentRoute.path,
          )
          .map(({ name, path }) => {
            return (
              <MenuItem key={name} onClick={() => handleClose(path)}>
                {name}
              </MenuItem>
            );
          })}
      </Menu>
    </Box>
  );
};
